import { checkJsApi } from "@voghion/native-api";
import { BridgeResponse } from "@voghion/native-api/types/utils/config";

type API = (params?: any) => Promise<BridgeResponse<any>>;

export async function checkApi<T extends API>(
  api: T,
  params?: T extends (_: infer R) => any ? R : never,
): Promise<T extends (_: any) => infer K ? K : never> {
  const authorizeAPISupport = await checkJsApi({
    api,
    ...params,
  });
  if (!authorizeAPISupport.result) {
    return undefined as any;
  }
  const res = (await api(params || {})) as any;

  return res;
}
